import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// Analytics
import mixpanel from 'mixpanel-browser';

// Redux
import { connect } from 'react-redux';

// Components
import Navbar from '../components/Navbar';
import Account_Settings from '../components/settings/Account_Settings';
import Billing_Settings from '../components/settings/Billing_Settings';
import { auth } from '../config/firebase-config';

const Settings = ({
  auth: {
    isAuthenticated,
    loading
  }
}) =>  {

  // Analytics 
  const [sentMixpanel, setSentMixpanel] = useState(false);

  // Which page to display
  const [page, handlePage] = useState(null);

    // Set which settings page to display
    useEffect(() => {
      let pathname = window.location.pathname;
      const pathArray = pathname.split('/');
      const settingsPage = pathArray[pathArray.length - 1];

      handlePage(settingsPage);

    }, [window.location]);

    // Redirect if the user is already logged in
  if(!isAuthenticated && !loading) {

    window.location.href = "/signin";
  }

  // Function to handle Mixpanel analytics
  const handleMixpanel = () => {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
    mixpanel.track("Settings Page View");
}

// Trigger Mixpanel analytics on initial render in production mode
if(process.env.NODE_ENV === 'production' && !sentMixpanel) {
    handleMixpanel();
    setSentMixpanel(true);
}

	return (
	  <Fragment>

        {/* Settings Grid Layout */}
        <div className='settings_grid'>
          
          {/* Sidebar */}
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <a href="/settings/account">
              <button className={page == 'account' ? 'active settings_menu_item' : 'settings_menu_item'}>
                Account
              </button>
            </a>
            <a href="/settings/billing">
              <button className={page == 'billing' ? 'active settings_menu_item' : 'settings_menu_item'}>
                Billing
              </button>
            </a>
          </div>

          {/* Main Body Section */}
          <div style={{width: '100%'}}>
            {/* Settings Pages */}
            {page == 'account' && <Account_Settings />}

            {page == 'billing' && <Billing_Settings />}
          </div>

        </div>
	  </Fragment>
	);
  }
  
Settings.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    // Mapping the authentication state
    auth: state.auth
});

export default connect(mapStateToProps, { 
    // Connecting actions to the component
})(Settings);
  